module.exports = __webpack_public_path__ + "img/gd-e-fes-mobile-man.d027b698.png";